import React from 'react';
import { Button, Icon } from '@kajabi/sage-react';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';
import useDiscard from 'common/components/CopyMagic/hooks/useDiscard';

const CloseButton = () => {
  const { discard } = useDiscard();
  const trackCloseClicked = useGeneratorTrackingCallback('useTrackCloseClicked');

  return (
    <Button
      color={Button.COLORS.SECONDARY}
      onClick={() => {
        discard();
        trackCloseClicked();
      }}
      icon={Icon.ICONS.REMOVE}
      iconOnly={true}
      subtle={true}
    >
      Close
    </Button>
  );
};

export default CloseButton;
